// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2DA4o","col":"CardReaderDesc_col__2vjSI","label":"CardReaderDesc_label__32lj4"};